module.exports = __webpack_public_path__ + "cd.eaf9c224.svg";